<div class="feature-not-available">
    <h3>This feature is not available on mobile</h3>
    <p>Please go to gosgc.com on a desktop browser to use it.</p>
    <button class="button" (click)="close()">Got it</button>
</div>